import { defineMessages } from 'react-intl';

export default defineMessages({
    creatingYourOfferingMessage: {
        id: 'policyview.ea.directives.MultiQuoteView.Please wait while we create your offering...',
        defaultMessage: 'Please wait while we create your offering...'
    },
    generalCoverages: {
        id: 'policyview.ea.directives.MultiQuoteView.General Coverages - Apply to all vehicles',
        defaultMessage: 'General Coverages - Apply to all vehicles'
    },
    vehicleSpecificCoverage: {
        id: 'policyview.ea.directives.MultiQuoteView.Vehicle-',
        defaultMessage: 'Vehicle-Specific Coverages - '
    },
    eaUnderwrtingGuidelines: {
        id: 'policyview.ea.quotePage.I verify this does not violate any of the',
        defaultMessage: 'I verify this does not violate any of the'
    },
    eaConsumerReport: {
        id: 'policyview.ea.quotePage.I accept the Consumer Report Disclosure ',
        defaultMessage: 'I accept the Consumer Report Disclosure'
    },
    eaLegalDisclaimer: {
        id: 'policyview.ea.quotePage.I agree that the information collected for this application can be used in my applications for other policies within the program',
        defaultMessage: 'I agree that the information collected for this application can be used in my applications for other policies within the program'
    },
    underliningGuidelineTitle: {
        id: 'policyview.ea.quotePage.underwritingGuidelines',
        defaultMessage: 'Underwriting Guidelines'
    },
    legalDisclaimerTitle: {
        id: 'policyview.ea.quotePage.legalDisclaimer',
        defaultMessage: 'Legal Disclaimer'
    },
    consumerReportTitle: {
        id: 'policyview.ea.quotePage.consumerReport',
        defaultMessage: 'Consumer Report'
    }
});
